import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { Autocomplete, Box, FormControl, Paper, TextField, } from "@mui/material";
import { useAccountByIdOrNumberQuery, useFinanceSummaryQuery, } from "generated/generated-models";
import TransactionListView from "app/transaction/TransactionListView";
import { CError } from "app/common/CError";
import { Loading } from "app/lib/components/Loading";
const TransactionsListForParty = () => {
    const { data: dataAccounts, loading: loadingAccounts, error: errorAccounts, } = useFinanceSummaryQuery();
    const accountsByPartyId = dataAccounts?.financeSummary?.Instruments?.flatMap((instrument) => instrument?.Accounts);
    const [listAccounts, setListAccounts] = React.useState([]);
    const [, setDetailView] = React.useState();
    const [selectedOptions, setSelectedOptions] = React.useState();
    const { data: dataAccountById } = useAccountByIdOrNumberQuery({
        variables: { idOrNumber: selectedOptions },
    });
    const accountById = dataAccountById?.accountByIdOrNumber;
    React.useEffect(() => {
        if (!loadingAccounts && dataAccounts) {
            const accountNumber = accountsByPartyId?.map((account) => account?.Number);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const accountNumberObject = accountNumber.map((item) => item);
            const firstAccount = accountNumberObject[0];
            setSelectedOptions(firstAccount);
            setListAccounts(accountNumberObject);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingAccounts, dataAccounts]);
    if (loadingAccounts) {
        return _jsx(Loading, {});
    }
    if (errorAccounts) {
        return (_jsx("section", { className: "sub-wrap", children: _jsx(CError, { error: "Could not retrieve account statements." }) }));
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleAccountChange = (_event, value) => {
        setSelectedOptions(value);
    };
    return (_jsxs("section", { className: "sub-wrap transactions-list", children: [_jsxs("div", { className: "list-header", children: [_jsx("h2", { children: "Transactions" }), _jsxs("span", { className: "list-subhead", children: ["For Account: ", selectedOptions] })] }), _jsx(Box, { className: "filterContainer", children: _jsx("div", { style: { width: "100%" }, children: _jsx(FormControl, { sx: { width: 220, mr: 3 }, size: "small", className: "filterControl", children: _jsx(Autocomplete, { id: "filtered-account-outlined", size: "small", options: listAccounts, disableClearable: true, onChange: handleAccountChange, getOptionLabel: (option) => option, defaultValue: selectedOptions, PaperComponent: ({ children }) => (_jsx(Paper, { style: { fontSize: "0.9rem" }, children: children })), renderInput: (params) => (_jsx(TextField, { ...params, label: "Account" })) }) }) }) }), _jsx(TransactionListView, { account: accountById, setDetailView: setDetailView })] }));
};
export default TransactionsListForParty;
